<template>
    <div>

        <!-- Start Services Details Area -->
		<section class="services-details-area ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
                <h2>E-Commerce Development</h2>
                <div class="bar"></div>
            </div>
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<h3>Incredible Infrastructure</h3>
							<p>One of the hardest decisions when choosing an e-commerce website is looking into the fact that which company provides you with the most amount of teachers and security solutions. </p>

							<p>WB set is a reputed and reliable ecommerce website development company which will let you bring your e-commerce website to life and help your business grow. Our team with years of experience and a vast knowledge in business strategies will help you find the perfect solution for your e-commerce website.</p>
						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/1.png" class="wow fadeInUp" v-wow alt="image">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/2.png" class="wow fadeInUp" v-wow alt="image">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<h3>Security</h3>
								<p>While making an eCommerce website security is the utmost priority from day one. We make sure that your data and your users data are fully secured and your transactions with your customers are one of the most secured in the market.</p>
							<h3>Design</h3>
								<p>	Our team will help you to embrace your design into a finished and polished product that I will bring a lot of customers to your Store.</p>
							<h3>Cost Effective</h3>
								<p>Our services are cost effective with on time deliveries.</p>
							<div class="services-details-accordion">
								<VueFaqAccordion 
									:items="myItems"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <!-- End Services Details Area -->
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';
export default {
	name: 'ECommerce',
	components: {
        VueFaqAccordion
    },
    data() {
        return {
            text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute.`,
                myItems: [
                {
                    title: 'Innovative Technology',
                    value: 'We leverage cutting-edge technology and methodologies to develop powerful sales automation software.'
                },
                {
                    title: 'Customer Partners',
                    value: 'We apply deep domain and hosting knowledge to support our clients’ technology and business goals.'
                },
                {
                    title: 'First-Rate Services',
                    value: 'We are committed to delivering best-in-class technology and customer service, building long lasting business partnerships.'
                }
            ]
        }
    }
}
</script>